import React from 'react';
import styled from 'styled-components';

import { colors } from '../../constants';
import { BaseListIcon } from '../../svg';

interface IProps {
    className?: string;
    onClick(): void;
}

const BaseListButton: React.FC<IProps> = ({ className, onClick }) => (
    <div className={className} onClick={onClick}>
        <BaseListIcon />
    </div>
);

export const ListButton = styled(BaseListButton)`
    border: 5px solid ${colors.primary};
    border-radius: 50px;
    width: 50px;
    height: 50px;
    background-color: ${colors.white};
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 24px;
        height: 24px;
        fill: ${colors.greyDark};
    }
`;
